// Engagement workspace pages by tab path (see ENGAGEMENT_TABS in app/nav.ts). To build out a tab, replace its component here.
import type { ComponentType } from "react";
import { ENGAGEMENT_TABS } from "../../app/nav";
import { AgentsTab } from "./Agents";
import { AreasPage } from "./Areas";
import { ClientPage } from "./Client";
import { CompletionPage, PlanningPage, SingleAuditPage } from "./Documents";
import { EvidencePage } from "./Evidence";
import { FilePage } from "./File";
import { FlowPage } from "./Flow";
import { HealthPage } from "./Health";
import { OverviewPage } from "./Overview";
import { ReleasePage } from "./Release";

const BY_PATH: Record<(typeof ENGAGEMENT_TABS)[number]["path"], ComponentType> = {
  "": OverviewPage, flow: FlowPage, file: FilePage, evidence: EvidencePage, planning: PlanningPage, areas: AreasPage,
  "single-audit": SingleAuditPage, completion: CompletionPage, client: ClientPage, agents: AgentsTab, health: HealthPage, release: ReleasePage,
};

export const ENGAGEMENT_PAGES = ENGAGEMENT_TABS.map((t) => ({ path: t.path, Page: BY_PATH[t.path] }));
